import { useState } from 'react';

export const useEditBlock = (setActiveSelect) => {
    const [isShowRoundingOption, setIsShowRoundingOption] = useState(false);

    const onEditRoundingOption = (roundingValue) => {
        setActiveSelect('');
        setIsShowRoundingOption(false);
        positionMassEditManager.newMassChangeRoundingType(roundingValue);
    };

    const onClickRoundingOption = () => {
        setIsShowRoundingOption(!isShowRoundingOption);
    };

    const rename = (e) => {
        e.stopPropagation();
        setActiveSelect('');
        $.modalable('open', {
            content: '.popup-mass-name',
        });
    };

    const changeMargin = (e) => {
        e.stopPropagation();
        setActiveSelect('');
        $.modalable('open', {
            content: '.popup-mass-margin',
        });
    };

    const changePrice = (e) => {
        e.stopPropagation();
        setActiveSelect('');
        $.modalable('open', {
            content: '.popup-mass-price',
        });
    };

    const changeCustomerPrice = (e) => {
        e.stopPropagation();
        setActiveSelect('');
        $.modalable('open', {
            content: '.popup-mass-customer-price',
        });
    };

    const changeUnit = (e) => {
        e.stopPropagation();
        setActiveSelect('');
        $.modalable('open', {
            content: '.popup-mass-unit',
        });
    };

    const remove = (e) => {
        e.stopPropagation();
        setActiveSelect('');
        positionMassEditManager.newMassRemove();
    };
    return {
        rename,
        changeMargin,
        changePrice,
        changeCustomerPrice,
        changeUnit,
        remove,
        isShowRoundingOption,
        onEditRoundingOption,
        onClickRoundingOption,
    };
};
